var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroStudioCassolato(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 640,
    viewBox: "0 80 960 640",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Persone, processi e software intorno all\u2019azienda") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Un percorso arancione collega tre persone, un flusso di lavoro e un software su misura.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lane",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8d3a1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#eb5b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28c40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.18
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-65 711C76 711 67 267 216 267S323 684 442 684C495 684 453 427 475 330S535 208 667 208C811 208 783 128 1027 128",
    fill: "none",
    stroke: "#eb5b1b",
    strokeWidth: 28,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    filter: "url(#glow)",
    d: "M-65 711C76 711 67 267 216 267S323 684 442 684C495 684 453 427 475 330S535 208 667 208C811 208 783 128 1027 128",
    fill: "none",
    stroke: "url(#lane)",
    strokeWidth: 12,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 -78)",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 220,
    width: 328,
    height: 210,
    rx: 36,
    fill: "#fffdfa"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 300,
    r: 48,
    fill: "#f5ddc9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 337Q208 311 237 312Q267 311 270 337A48 48 0 0 1 204 337",
    fill: "#c45223"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 237,
    cy: 293,
    rx: 21,
    ry: 24,
    fill: "#dca176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 293Q209 262 238 263Q264 264 259 293Q242 288 236 276Q232 289 215 293",
    fill: "#483128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 301Q237 308 245 301",
    fill: "none",
    stroke: "#ad6e4b",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 368,
    r: 42,
    fill: "#ece3d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 397Q112 373 139 374Q166 373 170 397A42 42 0 0 1 108 397",
    fill: "#685446"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139,
    cy: 360,
    rx: 19,
    ry: 23,
    fill: "#edbc92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 361Q116 331 140 334Q164 332 159 360L149 352L141 340Q135 355 119 361",
    fill: "#382b24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 368Q139 375 146 368",
    fill: "none",
    stroke: "#bc865e",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 368,
    r: 42,
    fill: "#f8e6d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 397Q309 373 336 374Q363 373 367 397A42 42 0 0 1 305 397",
    fill: "#df793e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336,
    cy: 360,
    rx: 19,
    ry: 23,
    fill: "#bd805d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 364L315 348Q316 332 336 333Q357 333 357 352L355 365L349 349Q332 357 322 345Z",
    fill: "#594137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 368Q336 374 343 368",
    fill: "none",
    stroke: "#895237",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 343L196 328M278 328L301 343M183 380H292",
    fill: "none",
    stroke: "#d9bda4",
    strokeWidth: 2,
    strokeDasharray: "4 7",
    opacity: 0.85
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 -36)",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 626,
    width: 326,
    height: 108,
    rx: 32,
    fill: "#fffdfa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149 680H329",
    stroke: "#d8b797",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 675L193 680L187 685M280 675L286 680L280 685",
    stroke: "#a27757",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 652,
    width: 57,
    height: 57,
    rx: 17,
    fill: "#f3dfcd"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#915338",
    fill: "none",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 668H146M128 677H149M128 686H140"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 652,
    width: 57,
    height: 57,
    rx: 17,
    fill: "#6d4a35"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff4e8",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 672H247V689H231Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 668V676M243 668V676M227 676H235M227 684H235M243 676H251M243 684H251M235 685V693M243 685V693"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 652,
    width: 57,
    height: 57,
    rx: 17,
    fill: "#eb5b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 680L337 689L355 671",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 -88)",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 350,
    width: 393,
    height: 281,
    rx: 30,
    fill: "#fffdfa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M532 350H871Q898 350 898 377V399H505V377Q505 350 532 350",
    fill: "#f6eade"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 375,
    r: 4,
    fill: "#bc9477"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544,
    cy: 375,
    r: 4,
    fill: "#d5b49a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558,
    cy: 375,
    r: 4,
    fill: "#e6ceba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 698,
    y: 366,
    width: 168,
    height: 17,
    rx: 8.5,
    fill: "#e6d3c1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 419,
    width: 62,
    height: 191,
    rx: 13,
    fill: "#f4e8dc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 439,
    width: 33,
    height: 28,
    rx: 8,
    fill: "#d45e25"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d4b79e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 483,
    width: 31,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 504,
    width: 31,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 525,
    width: 22,
    height: 5,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 420,
    width: 112,
    height: 83,
    rx: 16,
    fill: "#fae0c8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#bf5423",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633 445L648 437L663 445V463L648 472L633 463ZM633 445L648 454L663 445M648 454V472"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 676,
    y: 443,
    width: 24,
    height: 5,
    rx: 2.5,
    fill: "#d7a080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676,
    y: 456,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#e7bda0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738,
    y: 420,
    width: 139,
    height: 83,
    rx: 16,
    fill: "#eee8e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 476V458M775 476V444M793 476V451",
    stroke: "#9b7a62",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 474L829 459L840 463L859 439",
    fill: "none",
    stroke: "#d55c23",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 520,
    width: 268,
    height: 90,
    rx: 16,
    fill: "#faf5ee"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d3baa5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 538,
    width: 109,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 558,
    width: 152,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 578,
    width: 90,
    height: 5,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#e67b3f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 848,
    cy: 541,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848,
    cy: 561,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848,
    cy: 581,
    r: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M705 631V668",
    stroke: "#bd997b",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 692,
    r: 16,
    fill: "#fffdfa",
    stroke: "#e6d3c1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 692,
    r: 16,
    fill: "#fffdfa",
    stroke: "#e6d3c1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 668Q705 692 656 692",
    stroke: "#bd997b",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 668Q705 692 754 692",
    stroke: "#bd997b",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStudioCassolato);
export default __webpack_public_path__ + "static/media/hero-studio-cassolato.1ac9c770586db93085a53360baf8cc05.svg";
export { ForwardRef as ReactComponent };